const Footer = () => {
  return (
    <footer className="bg-blue-800 text-white text-sm text-center py-4 mt-12">
      © 2026 ICCK Tampere — All Rights Reserved
    </footer>
  );
};

export default Footer;